import React from 'react';
import styles from './TextEffectsNoisy.scss';
import type { TextEffectsSharedProps } from '../../TextEffectsShared/TextEffectsShared.types';
import TextEffectsShared from '../../TextEffectsShared/viewer/TextEffectsShared';
import { TestIds, noiseIntensityConfig } from '../constants';
import { range } from '../../TextEffectsShared/editor/panels/design/utils';
import useUniqueSvg, {
  createSvgManager,
} from '../../TextEffectsShared/viewer/useUniqueSvg';
import { usePatterns } from '../../TextEffectsShared/viewer/patterns/usePatterns';
import { Patterns } from '../../TextEffectsShared/viewer/patterns/Patterns';

const svgManager = createSvgManager(`
  <defs>
    ${range(
      noiseIntensityConfig.start,
      noiseIntensityConfig.end,
      noiseIntensityConfig.step,
    )
      .map(
        scale => `
      <filter id="noisy_squiggly:${scale}">
        <feTurbulence
          baseFrequency="0.08"
          numOctaves="13"
          result="noise"
          seed="0"
        />
        <feDisplacementMap
          in2="noise"
          in="SourceGraphic"
          scale="${scale}"
        />
      </filter>
    `,
      )
      .join('\n')}
  </defs>
`);

export type TextEffectsNoisyProps = TextEffectsSharedProps;

const TextEffectsNoisy: React.FC<TextEffectsSharedProps> = props => {
  const { content, arePatternsDisabled } = usePatterns(props);

  useUniqueSvg(svgManager);

  return (
    <TextEffectsShared
      {...props}
      arePatternsDisabled={arePatternsDisabled}
      tagProps={{
        'data-testid': TestIds.viewer.container,
      }}
    >
      <Patterns
        content={content}
        arePatternsDisabled={arePatternsDisabled}
        patternScope={props.patternScope}
        unitProps={() => ({
          className: styles.container,
          'data-testid': TestIds.viewer.text,
          disabledPattern: arePatternsDisabled,
        })}
      />
    </TextEffectsShared>
  );
};

export default TextEffectsNoisy;
